import { useExperienceId } from '@vizsla/hooks';

import { useExperienceById } from './useExperienceById';

export const useCurrentExperience = () => {
  const experienceId = useExperienceId();
  return useExperienceById(experienceId);
};
